const stationsLookup = {
    "Alachua": 260,
    "Apopka": 320,
    "Arcadia": 490,
    "Avalon": 304,
    "Babson Park": 400,
    "Balm": 350,
    "Belle Glade": 410,
    "Bristol": 190,
    "Bronson": 230,
    "Brooksville South": 315,
    "Brooksville": 310,
    "Carrabelle": 150,
    "Citra": 250,
    "Clewiston": 405,
    "Dade City": 311,
    "DeFuniak Springs": 120,
    "Dover": 360,
    "Fort Lauderdale": 420,
    "Fort Pierce": 430,
    "Frostproof": 390,
    "Hastings": 270,
    "Homestead": 440,
    "Immokalee": 450,
    "Indian River": 371,
    "Jay": 110,
    "Joshua": 241,
    "Kenansville": 340,
    "Lake Alfred": 330,
    "Lecanto": 275,
    "Live Oak": 170,
    "Macclenny": 180,
    "Marianna": 130,
    "Mayo": 121,
    "Monticello": 160,
    "North Port": 480,
    "Ocklawaha": 280,
    "Okahumpka": 303,
    "Okeechobee": 455,
    "Ona": 380,
    "Palmdale": 460,
    "Pierson": 290,
    "Putnam Hall": 240,
    "Quincy": 140,
    "Sebring": 470,
    "St. Lucie West": 435,
    "StrawBerry Floral City": 261,
    "StrawBerry Plant City": 111,
    "Umatilla": 302,
    "Wellington": 425,
};

export {
    stationsLookup
};
